import { all, fork } from 'redux-saga/effects'
import { watchSignIn, watchFetchAllUsers } from './Sagas'

export default function* rootSaga() {
    yield all( [
        fork( watchSignIn ),
        fork( watchFetchAllUsers )
    ] )
}